// extracted by mini-css-extract-plugin
export default {"chartjs__wrapper":"ChartJs_chartjs__wrapper__xYa6f"};